type Props = {
    [x: string]: any;
}

const TextError = (props:Props) => {
  return (
    <div className="invalid-feedback" role="alert">{props.children}</div>
  )
}

export default TextError